import { AxiosInstance, AxiosRequestConfig } from 'axios';

const ENDPOINT = 'shelves/';

export type ShelvesVisitPhoto = {
  filename?: string;
  content?: string;
};

export type ShelvesVisitShelf = {
  shelves_category_id: number;
  photos?: ShelvesVisitPhoto[];
};

export type ShelvesVisitPayload = {
  outlet_id: number;
  visit_dt: string;
  shelves: ShelvesVisitShelf[];
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  visitShelves: (payload: ShelvesVisitPayload) =>
    instance.post<ApiResponse<any>>(ENDPOINT + 'visit/', payload, config),
});
